import React from "react";
import { Link } from "react-router-dom";
import { fmtRON } from "../lib/api";

export default function ProductCard({ product }) {
  const saving = product.original_price && product.original_price > product.price;
  return (
    <Link
      to={`/carti/${product.slug}`}
      className="product-card group block border bg-white"
      style={{ borderColor: "var(--vdz-cream-border)" }}
      data-testid={`product-card-${product.slug}`}
    >
      <div className="cover-wrap relative overflow-hidden aspect-[3/4]" style={{ background: "var(--vdz-navy)" }}>
        <img src={product.cover_image} alt={product.title} className="w-full h-full object-cover" loading="lazy" />
        {product.collection_label && (
          <span className="absolute top-3 left-3 px-3 py-1 text-[10px] uppercase tracking-[0.2em] font-serif-accent"
                style={{ background: product.is_bundle ? "var(--vdz-burgundy)" : product.seasonal ? "var(--vdz-burnt-orange)" : "var(--vdz-navy)", color: "var(--vdz-cream)" }}>
            {product.collection_label}
          </span>
        )}
        {saving && (
          <span className="absolute top-3 right-3 px-3 py-1 text-[10px] uppercase tracking-[0.18em] font-serif-accent"
                style={{ background: "var(--vdz-gold)", color: "var(--vdz-navy)" }}>
            -{Math.round(((product.original_price - product.price) / product.original_price) * 100)}%
          </span>
        )}
      </div>
      <div className="p-5">
        <h3 className="font-serif-display text-xl md:text-2xl leading-tight" style={{ color: "var(--vdz-navy)" }}>{product.title}</h3>
        {product.subtitle && <div className="text-xs mt-1 opacity-70">{product.subtitle}</div>}
        <p className="text-sm mt-3 opacity-70 clamp-2">{product.short_description}</p>
        <div className="flex items-end justify-between mt-5">
          <div>
            {saving && <div className="text-xs line-through opacity-50">{fmtRON(product.original_price)}</div>}
            <div className="font-serif-display text-2xl gold-text">{fmtRON(product.price)}</div>
          </div>
          <span className="font-serif-accent uppercase tracking-[0.18em] text-[10px] text-[color:var(--vdz-navy)] group-hover:text-[color:var(--vdz-gold)]">
            Vezi carte →
          </span>
        </div>
      </div>
    </Link>
  );
}
